export enum RsjCredentialType {
  ValidIdentityFr = 'ValidIdentityFr',
  ExpiredIdentityFr = 'ExpiredIdentityFr',
  NoIdentityFr = 'NoIdentityFr',
  ValidIdentityEU = 'ValidIdentityEU',
  ResidentCard = 'ResidentCard',
  ValidRenewal = 'ValidRenewal',
  CJM = 'CJM',
  Other = 'Other',
}

export enum RsjCredentialTypeLabel {
  ValidIdentityFr = "Pièce d'identité en cours de validité",
  ExpiredIdentityFr = "Pièce d'identité périmée",
  NoIdentityFr = "Absence de pièce d'identité",
  ValidIdentityEU = "Pièce d'identité en cours de validité",
  ResidentCard = 'Carte de résident ou titre de séjour en cours de validité',
  ValidRenewal = 'Récépissé renouvellement en cours de validité',
  CJM = 'Ex-MNA avec récépissé de demande de CJM',
  Other = 'Autre',
}

export function credentialTypesByNationality(nationality: string): RsjCredentialType[] {
  switch (nationality) {
    case 'French':
      return [RsjCredentialType.ValidIdentityFr, RsjCredentialType.ExpiredIdentityFr, RsjCredentialType.NoIdentityFr];
    case 'European':
      return [RsjCredentialType.ValidIdentityEU];
    case 'NotEuropean':
      return [RsjCredentialType.ResidentCard, RsjCredentialType.ValidRenewal, RsjCredentialType.CJM, RsjCredentialType.Other];
    default:
      return [];
  }
}
